import { Controller, useForm } from "react-hook-form";
import { COMMENT_OBJECT_TYPE } from "common/constants";
import { useCreateCommentMutation } from "../../generated/graphql";
import { useStatusToasts } from "../../hooks/useStatusToasts";
import { Button } from "../Common/Buttons/Button";
import { RichText } from "../Inputs/RichText";
import { ButtonRow } from "./__styles__/Thread";

export const CreateComment = ({
  refetchComments,
  objectId,
  objectType,
}: {
  refetchComments: () => void;
  objectId: string;
  objectType: COMMENT_OBJECT_TYPE;
}) => {
  const { addErrorToast } = useStatusToasts();
  const { control, watch, handleSubmit, reset } = useForm<{
    comment: string;
  }>();

  const [createComment, { loading }] = useCreateCommentMutation({
    onCompleted: () => {
      reset();
      void refetchComments();
    },
    onError: () =>
      addErrorToast(
        "There was an error adding this comment. Please try again. If the problem persists, please email us at support@withforerunner.com",
      ),
  });

  const commentValue = watch("comment");

  const onSubmit = async (data: { comment: string }) => {
    await createComment({
      variables: {
        data: {
          content: data.comment,
          objectId,
          objectType,
        },
      },
    });
  };
  return (
    <div>
      <Controller
        name="comment"
        control={control}
        render={({ field, fieldState }) => (
          <RichText
            name={field.name}
            value={field.value || ""}
            placeholder="Leave a comment..."
            onChange={field.onChange}
            error={fieldState.error?.message}
          />
        )}
      />
      <ButtonRow>
        <Button
          variant={commentValue ? "primary" : "secondary"}
          size="small"
          icon="arrow-up"
          aria-label="Add comment"
          isDisabled={!commentValue}
          isPending={loading}
          onClick={handleSubmit(onSubmit)}
        />
      </ButtonRow>
    </div>
  );
};
